/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {ApiConfig} from '../../config/api-config';
import {AdnApiClientService} from './adn-api-client.service';

@Injectable({providedIn: 'root'})
export class ElectionApiService {
  constructor(private readonly client: AdnApiClientService, private readonly apiConfig: ApiConfig) {
  }

  list(params: Record<string, any> = {}): Observable<any> {
    return this.client.request({
      method: 'GET',
      url: this.apiConfig.getVersionedUri('elections'),
      params
    });
  }
}
